/** Checkbox that can show "some of its children" (mixed). Styles: import-template-modal.css */
const ImportCheck = ({ state, onToggle, label }) => (
  // biome-ignore lint/a11y/useSemanticElements: the design's gradient checkbox, with a mixed state a native input can't style
  <span
    role="checkbox"
    tabIndex={0}
    aria-checked={state === "some" ? "mixed" : state === "all"}
    aria-label={label}
    className={`imp-check ${
      state === "all" ? "on" : state === "some" ? "mixed" : ""
    }`}
    onClick={(event) => {
      event.stopPropagation();
      onToggle();
    }}
    onKeyDown={(event) => {
      if (event.key === " " || event.key === "Enter") {
        event.preventDefault();
        event.stopPropagation();
        onToggle();
      }
    }}
  />
);

export default ImportCheck;
